import { boolean, number, object, ObjectSchema, string } from 'yup';

import { RemitAdjustment } from '@/types/billing';
import { transformEmptyStringToNull } from '@/utils/transformEmptyStringToNull';

export const RemitAdjustmentSchema: ObjectSchema<
  Omit<RemitAdjustment, 'remit_service_line' | 'created_at' | 'updated_at' | 'id'>
> = object().shape({
  group_code: string().trim().max(100).required().transform(transformEmptyStringToNull),
  reason_code: string().trim().max(100).required().transform(transformEmptyStringToNull),
  amount: string().trim().max(100).required().transform(transformEmptyStringToNull),
  amount_in_cents: number().integer().min(-2147483648).max(2147483647).nullable(),

  _delete: boolean().optional()
});
